import { IconX } from '@tabler/icons-react'
import { ClearIndicatorProps, components as RSComponents, GroupBase } from 'react-select'

import { SizeOptions } from '../../../../types/types'
import { AstraIcon } from '../../../AstraIcon/AstraIcon'
import { AstraButton } from '../../AstraButton/AstraButton'
import { SelectOption } from '../../AstraSelect'

export type AstraMultiSelectClearIndicatorProps<T> = ClearIndicatorProps<SelectOption<T>, true, GroupBase<SelectOption<T>>> & {
    size?: SizeOptions
}

export const AstraMultiSelectClearIndicator = <T,>({ clearValue, size = 'small', ...props }: AstraMultiSelectClearIndicatorProps<T>) => (
    <RSComponents.ClearIndicator clearValue={clearValue} {...props}>
        <AstraButton
            variant="ghost"
            size={size}
            onClick={event => {
                event.preventDefault()
                clearValue()
            }}
            icon={<AstraIcon icon={IconX} size="small" color="text-default" />}
        />
    </RSComponents.ClearIndicator>
)
